import React, { useMemo } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { themeSettings } from "./theme/theme";
import { useSelector } from "react-redux";
import ScrollTop from "./components/ScrollTop";
import HomePage from "./scenes/homepage";
import AdminPage from "./scenes/adminPage";
import LoginPage from "scenes/loginPage";
import PasswordResetEmailSent from "scenes/loginPage/passwordResetEmailSent";
import ResetPasswordForm from "scenes/loginPage/components/resetPasswordForm";
import Layout from "scenes/layout";
import { checkRoles } from "utils/permissions";
import EmissionRecords from "scenes/EmissionsRecords";
import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import TestErrorComponent from "components/ErrorBoundary/TestErrorBoundary";

function App() {
  const mode = useSelector((state) => state.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
  const isAuth = Boolean(useSelector((state) => state.token));

  const user = useSelector((state) => state.user);
  const { isSystemAdmin } = checkRoles(user);

  return (
    <div className="app">
      <ErrorBoundary theme={theme}>
        <HelmetProvider>
          <BrowserRouter>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <ScrollTop />
              <Routes>
                <Route path="/test-error" element={<TestErrorComponent />} />
                {/* Public Routes */}
                <Route path="/" element={<LoginPage />} />
                <Route
                  path="/password-reset-sent"
                  element={<PasswordResetEmailSent />}
                />
                {/* Password Reset Route (Public) */}
                <Route
                  path="/reset-password/:token"
                  element={<ResetPasswordForm />}
                />
                <Route path="/" element={<Layout />}>
                  <Route
                    path="/home"
                    element={isAuth ? <HomePage /> : <Navigate to="/" />}
                  />
                  <Route
                    path="/ingredients"
                    element={isAuth ? <EmissionRecords /> : <Navigate to="/" />}
                  />
                  {isSystemAdmin && (
                    <Route
                      path="/admin"
                      element={isAuth ? <AdminPage /> : <Navigate to="/" />}
                    />
                  )}
                </Route>

                {/* Handle unknown routes based on authentication */}
                <Route
                  path="*"
                  element={
                    isAuth ? <Navigate to="/home" /> : <Navigate to="/" />
                  }
                />
              </Routes>
            </ThemeProvider>
          </BrowserRouter>
        </HelmetProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
